import { ColumnData } from './data'
import { Element } from './element'
import { AccordionWidget } from './accordion-widget'
import { BasicGalleryWidget } from './basic-gallery-widget'
import { ButtonWidget } from './button-widget'
import { BlockQuoteWidget } from './block-quote-widget'
import { HeadingWidget } from './heading-widget'
import { HtmlWidget } from './html-widget'
import { IconListWidget } from './icon-list-widget'
import { ImageWidget } from './image-widget'
import { ImageBoxWidget } from './image-box-widget'
import { TableWidget } from './table-widget'
import { TextEditorWidget } from './text-editor-widget'
import { Section, InnerSection } from './section'
import { TestimonialWidget } from './testimonial-widget'
import { VideoWidget } from './video-widget'
import { SlidesWidget } from './slides-widget'

type Widgets = AccordionWidget | BasicGalleryWidget | ButtonWidget |
BlockQuoteWidget | HeadingWidget | HtmlWidget | IconListWidget |
ImageWidget | ImageBoxWidget | TableWidget | TextEditorWidget |
TestimonialWidget | VideoWidget | SlidesWidget

export class Column<Outer extends boolean> extends Element {
  elements: Outer extends true ?
    Array<Widgets | InnerSection> :
    Widgets[]

  constructor (data: ColumnData) {
    super(data)

    this.elements = []

    for (const elData of data.elements) {
      if (elData.elType === 'widget') {
        switch (elData.widgetType) {
          case 'accordion': this.elements.push(new AccordionWidget(elData)); break
          case 'image-gallery': this.elements.push(new BasicGalleryWidget(elData)); break
          case 'button': this.elements.push(new ButtonWidget(elData)); break
          case 'blockquote': this.elements.push(new BlockQuoteWidget(elData)); break
          case 'heading': this.elements.push(new HeadingWidget(elData)); break
          case 'html': this.elements.push(new HtmlWidget(elData)); break
          case 'icon-list': this.elements.push(new IconListWidget(elData)); break
          case 'image': this.elements.push(new ImageWidget(elData)); break
          case 'image-box': this.elements.push(new ImageBoxWidget(elData)); break
          case 'Table': this.elements.push(new TableWidget(elData)); break
          case 'text-editor': this.elements.push(new TextEditorWidget(elData)); break
          case 'testimonial-carousel': this.elements.push(new TestimonialWidget(elData)); break
          case 'video': this.elements.push(new VideoWidget(elData)); break
          case 'slides': this.elements.push(new SlidesWidget(elData)); break
        }
      } else if (elData.elType === 'section' && this.isOuter(data)) {
        this.elements.push(new Section<false>(elData))
      } else {
        throw new TypeError(`unrecognized element type "${elData.elType}"`)
      }
    }
  }

  /**
   * A hacky(?) type guard for <this> being an outer or inner column depending on the data at hand.
   */
  private isOuter (data: ColumnData): this is Column<true> {
    return !data.isInner
  }
}
